<section class="pas-dashboard">
    @if (!showSurveyDetails) {
    <div class="dashboard-header">
        <div class="header-top">
            <div class="header-text">
                <h2 class="title">{{ title }}</h2>
                <p class="subtitle">Select a survey to view details</p>
            </div>
        </div>
        <div class="header-controls">
            <div class="search-box">
                <input #searchInput type="text" placeholder="Search survey(s)..." class="search-input"
                    [value]="searchTerm" (input)="onSearchChange(searchInput.value)">
            </div>
            <p class="events-count" aria-live="polite">Showing {{ displayedCount }} of {{ totalCount }} survey(s)</p>
            <div class="filter-chips">
                <button type="button" class="filter-chip" [class.active]="isFilterSelected('Active')"
                    (click)="toggleFilter('Active')">
                    Active
                    @if (isFilterSelected('Active')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
                <button type="button" class="filter-chip" [class.upcoming]="isFilterSelected('Upcoming')"
                    (click)="toggleFilter('Upcoming')">
                    Upcoming
                    @if (isFilterSelected('Upcoming')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
                <button type="button" class="filter-chip" [class.completed]="isFilterSelected('Completed')"
                    (click)="toggleFilter('Completed')">
                    Completed
                    @if (isFilterSelected('Completed')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
            </div>
        </div>
    </div>

    <div class="card-grid">
        @if (isLoading) {
        @for (skeleton of [1, 2, 3]; track skeleton) {
        <div class="header-card-new pas-card-skeleton" aria-hidden="true">
            <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="260px"
                borderRadius="8px"></app-loading-skeleton>
        </div>
        }
        } @else {
        @for (card of filteredCards; track card.surveyId) {
        <div class="header-card-new" [class.active]="card.status === 'Active'"
            [class.upcoming]="card.status === 'Upcoming'" [class.completed]="card.status === 'Completed'"
            (click)="openSurvey(card)">
            <div class="card-top-section-new">
                <div class="first-column">
                    <span class="card-title">{{ card.eventName }}</span>
                    <div class="activity-status" [class.active]="card.status === 'Active'"
                        [class.upcoming]="card.status === 'Upcoming'" [class.completed]="card.status === 'Completed'">
                        {{ card.status }}
                    </div>
                </div>
                <div class="second-column">
                    <div class="card-date-row">
                        <span class="date-label">
                            <i class="fa-regular fa-calendar date-icon" aria-hidden="true"></i>
                            @if(card.status === 'Upcoming') {
                            <span>Survey Opens On:</span>
                            <span class="date-value">{{ card.startDate }}</span>
                            } @else if(card.status === 'Active') {
                            <span>Survey Started On:</span>
                            <span class="date-value">{{ card.startDate }}</span>
                            } @else if(card.status === 'Completed') {
                            <span>Survey Closed</span>
                            }
                        </span>
                    </div>
                </div>
            </div>
            <div class="card-bottom-section">
                <div class="card-registered-row">
                    <div class="first-column">
                        @if (isLoading) {
                        <div class="stat-loading">
                            <app-loading-skeleton [count]="1" width="100%" height="24px" borderRadius="4px"></app-loading-skeleton>
                        </div>
                        } @else {
                        <span class="registered-count">{{ card.totalRegistrations | number }}</span>
                        }
                        <span class="registered-label">
                            <i class="fa-solid fa-user-group stat-icon" aria-hidden="true"></i>
                            <span>Registrants</span>
                        </span>
                    </div>
                    <div class="second-column">
                        @if (isLoading) {
                        <div class="stat-loading">
                            <app-loading-skeleton [count]="1" width="100%" height="24px" borderRadius="4px"></app-loading-skeleton>
                        </div>
                        } @else {
                        <span class="registered-count">{{ card.surveyCompletionPercentage }}</span>
                        }
                        <span class="registered-label">
                            <i class="fa-solid fa-comment-dots stat-icon" aria-hidden="true"></i>
                            <span>Responses Collected</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        }
        }
    </div>
    } @else {
    <div class="survey-wrapper">
        <ng-container *ngComponentOutlet="surveyComponent; inputs: surveyInputs"></ng-container>
    </div>
    }
</section>
